import AdminRootContainer from "@/app/admin/_common/AdminRootContainer";
import DevBanner from "@/app/components/DevBanner";
import AdminRouteOutlet from "./AdminRouteOutlet";

export default function AdminShell() {
  return (
    <AdminRootContainer>
      <DevBanner />
      <AdminRouteOutlet />
    </AdminRootContainer>
  );
}
